import { Injectable } from '@angular/core'
import { lazyLoadedModulesMap } from 'src/app/data/lazy-loaded-modules'
import { LoadChildrenCallback } from '@angular/router'

@Injectable({ providedIn: 'root' })
export class LazyLoadingService {
  getLoadChildrenCallback(key: string): LoadChildrenCallback {
    const lazyModule: LoadChildrenCallback = lazyLoadedModulesMap[key]
    if (!lazyModule) throw new Error(`Lazy loaded module not found with key ${key}`)
    return lazyModule
  }
}
